import { getHttpClient } from "@/http-client";
const baseURL = "api/boss/electronic_application_quotes";

export async function deleteElectronicApplicationQuote(id) {
  return getHttpClient().put(`${baseURL}/${id}/archive`);
}
